export { default, getStaticProps } from "app/seo/comment-ca-marche/page";
